module.exports = {
          srcSet: __webpack_public_path__ + "0e21b1fb.jpg"+" 330w",
          images:[ {path: __webpack_public_path__ + "0e21b1fb.jpg",width: 330,height: 200}],
          src: __webpack_public_path__ + "0e21b1fb.jpg",
          toString:function(){return __webpack_public_path__ + "0e21b1fb.jpg"},
          
          width: 330,
          height: 200
        }